import { render, staticRenderFns } from "./ResourceAcceptedVisits.vue?vue&type=template&id=63b18bfa&scoped=true"
import script from "./ResourceAcceptedVisits.vue?vue&type=script&lang=ts"
export * from "./ResourceAcceptedVisits.vue?vue&type=script&lang=ts"
import style0 from "./ResourceAcceptedVisits.vue?vue&type=style&index=0&id=63b18bfa&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b18bfa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63b18bfa')) {
      api.createRecord('63b18bfa', component.options)
    } else {
      api.reload('63b18bfa', component.options)
    }
    module.hot.accept("./ResourceAcceptedVisits.vue?vue&type=template&id=63b18bfa&scoped=true", function () {
      api.rerender('63b18bfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projects/activities/ResourceAcceptedVisits.vue"
export default component.exports